export default "__VITE_ASSET__D0D$ldBD__"